import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { Button, Container, Grid, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DownloadIcon } from '../../../../icons/DownloadIcon';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import { ViewIcon } from '../../../../icons/ViewIcon';

const Header = styled(Grid)(({ theme }) => ({
  float: 'left',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
  },
}));

const Heading = styled(Typography)({
  position: 'relative',
  marginTop: '20px',
});

const PaperContainer = styled(Grid)(({ theme }) => ({
  float: 'right',
  marginRight: '1em',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
    justifyContent: 'center',
    margin: '0 0 2.5em 0',
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '1.5em',
  borderRadius: '8px',
  maxWidth: '400px',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

const DownloadButton = styled(Button)(({ theme }) => ({
  clear: 'left',
  marginTop: '2em',
  '& svg': {
    position: 'relative',
    left: '-5px',
  },
  [theme.breakpoints.down('md')]: {
    clear: 'initial',
    marginBottom: '2em',
  },
}));

const ViewButton = styled(Button)({
  marginTop: '2em',
  '& svg': {
    position: 'relative',
    left: '-5px',
  },
});

interface ConnectionFailedProps {
  openModal: () => void;
}

export function ConnectionFailed({ openModal }: ConnectionFailedProps) {
  const { downloadFinalTestResults } = useAppStateContext();

  return (
    <>
      <Container>
        <div>
          <Header item lg={5}>
            <Heading variant="h1" gutterBottom>
              <ErrorIcon />
              Connection failed
            </Heading>

            <Typography variant="body1" gutterBottom>
              It's possible that you're behind a firewall that will need to be updated by your network administrator.
            </Typography>
          </Header>

          <PaperContainer item lg={5}>
            <StyledPaper>
              <Typography variant="body1" gutterBottom>
                To conduct a video call, your internet needs to be able to communicate with Twilio's cloud.
              </Typography>

              <Typography variant="body1">
                Learn{' '}
                <a href="https://www.twilio.com/docs/video/ip-addresses" target="_blank" rel="noopener noreferrer">
                  how to configure your firewall correctly
                </a>
                .
              </Typography>
            </StyledPaper>
            <ViewButton variant="outlined" onClick={openModal}>
              <ViewIcon />
              View detailed connection information
            </ViewButton>
          </PaperContainer>

          <Grid item lg={5}>
            <Typography variant="body1">
              Download report results to send to your network admin, update your internet, and re-run this test.
            </Typography>

            <DownloadButton
              variant="contained"
              color="primary"
              onClick={downloadFinalTestResults}
            >
              <DownloadIcon />
              Download report results
            </DownloadButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
